import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
//pc端
import HomePage from '../views/HomePage/index.vue';
import About from '../views/About/index.vue';
import ProductCenter from '../views/ProductCenter/index.vue';
import Information from '../views/Information/index.vue';
import InformationDetail from '../views/Information/informationDetail.vue';
import Try from '../views/Try/index.vue';
import ContactUs from '../views/ContactUs/index.vue';
import IOTDetails from '../views/IOTDetails/index.vue';
import NBDetails from '../views/NBDetails/index.vue';
import ProductDetails from '../views/ProductDetails/index.vue';
import Err404 from '../views/Err404/index.vue';
//移动端
import HomePage_m from '../views/Wap/HomePage/index.vue';
import About_m from '../views/Wap/About/index.vue';
import ProductCenter_m from '../views/Wap/ProductCenter/index.vue';
import Try_m from '../views/Wap/Try/index.vue';
import ContactUs_m from '../views/Wap/ContactUs/index.vue';
import ProductDetails_m from '../views/Wap/ProductDetails/index.vue';
Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,//首页
    meta: {
      title: '首页入口'
    }
  }, 
  {
    path: '/about',
    name: 'About',
    component: About,//关于我们
  },
  {
    path: '/productCenter',
    name: 'ProductCenter',
    component: ProductCenter,//产品中心  
  },
  {
    path: '/information',
    name: 'Information',
    component: Information,//新闻资讯  
  },
  {
    path: '/informationDetail/:id',
    name: 'InformationDetail',
    component: InformationDetail,//新闻资讯  
  },
  {
    path: '/try',
    name: 'Try',
    component: Try,//试用
  },
  {
    path: '/contactUs',
    name: 'ContactUs',
    component: ContactUs,//联系我们
  },
  {
    path: '/iOTDetails',
    name: 'IOTDetails',
    component: IOTDetails,//IOT燃气表详情页
  },
  {
    path: '/nBDetails',
    name: 'NBDetails',
    component: NBDetails,//NB燃气表详情页
  },
  {
    path: '/productDetails',
    name: 'ProductDetails',
    component: ProductDetails,//智能燃气管理平台详情页
  },

  {
    path: '/index_m',
    name: 'HomePage_m',
    component: HomePage_m,//手机端首页
  },
  {
    path: '/about_m',
    name: 'About_m',
    component: About_m,
  },
  {
    path: '/productCenter_m',
    name: 'ProductCenter_m',
    component: ProductCenter_m,
  },
  {
    path: '/try_m',
    name: 'Try_m',
    component: Try_m,
  },
  {
    path: '/contactUs_m',
    name: 'ContactUs_m',
    component: ContactUs_m,
  },
 
  {
    path: '/productDetails_m',
    name: 'ProductDetails_m',
    component: ProductDetails_m,
  },
  { 
    path: '*', 
    component: Err404,
   }
  /* {
    path: '/about2',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/About/index.vue'),
  }, */
];

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0}
  }
    
    
});

export default router;
